<template>
  <a-modal title="请输入删除密码" visible @cancel="cancel" @ok="ok">
    <a-form layout="vertical">
      <ak-type-input v-model="deletePassword" :field="deletePasswordOption" ref="pwd" />
    </a-form>
  </a-modal>
</template>

<script>
import { isNull } from '../../assets/js/validators'
export default {
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String // 假如当前model显示为category格式，则会将当前的值传入
  },
  data () {
    return {
      deletePassword: '',
      deletePasswordOption: {
        name: 'deletePassword',
        note: '密码',
        type: 'String',
        validators: [
          isNull
        ]
      }
    }
  },
  methods: {
    // 取消
    cancel () {
      this.$emit('complete', 'cancel')
    },
    // 确认
    async ok () {
      const flag = await this.valatedate()
      if (flag) {
        this.deleteOrder()
      } else {
        this.$notification.error({
          message: '数据错误',
          description: '数据错误'
        })
      }
    },
    async deleteOrder () {
      if (this.deletePassword === this.password) {
        try {
          if (this.record.status === 'financeVerify') { await this.$tkParse.delete(`/classes/verifyOrder/${this.record.objectId}`) } else {
            await this.$tkParse.delete(`/classes/Order/${this.record.objectId}`)
          }
          this.$emit('complete', 'cancel')
          this.vm.refresh()
          this.$notification.success({
            message: '删除成功',
            description: '数据已删除'
          })
        } catch (e) {
          this.$notification.error({
            message: '网络错误',
            description: '网络错误'
          })
        }
      } else {
        this.$notification.error({
          message: '数据错误',
          description: '密码错误'
        })
      }
    },
    async valatedate () {
      const res = await this.$refs.pwd.validate()
      return res === null
    },
    async getDeletePassword () {
      let { data: res } = await this.$tkParse.get('/settings')
      if (res.deleteOrderPassword) {
        this.password = res.deleteOrderPassword
      } else {
        this.password = '123456'
      }
    }
  },
  created () {
    this.getDeletePassword()
  }
}
</script>

<style></style>
